"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindHosts = void 0;
const actions_1 = require("./actions");
async function bindHosts(store) {
    try {
        const endopoint = getenv('REACT_APP_SERVER_URL') + 'hosts';
        const hostsRequest = await fetch(endopoint);
        const hosts = await hostsRequest.json();
        store.dispatch(actions_1.setHosts(hosts));
        store.dispatch(actions_1.setServerDown(false));
    }
    catch (e) {
        store.dispatch(actions_1.setServerDown(true));
        setTimeout(() => {
            bindHosts(store);
        }, 5000);
    }
}
exports.bindHosts = bindHosts;
